<template>
  <DpplDarkTooltip :hide-tooltip="!(isNoEditorMode && hasTooltip)">
    <template
      #activator="{
        onMouseenter: activatorOnMouseEnter,
        onMouseleave: activatorOnMouseLeave,
      }"
    >
      <div
        class="no-editor"
        :class="{ 'cursor-pointer': Boolean(redirectRoute) }"
        @mouseenter="activatorOnMouseEnter"
        @mouseleave="activatorOnMouseLeave"
        @click="handleClick"
      >
        <div
          class="w-100 h-100"
          :class="{
            'no-events': isNoEditorMode,
          }"
        >
          <slot />
        </div>

        <div
          v-if="isNoEditorMode && badgeText"
          class="badge"
          :style="badgeStyle"
        >
          {{ badgeText }}
        </div>
      </div>
    </template>
    <template #tooltip-content>
      <slot name="tooltip-content">
        <p class="first-paragraph">
          This feature isn’t available in the Insights plan
        </p>

        <p class="mt-2 second-paragraph">
          Upgrade to workflow plan to get unlimited drafts, AI-powered editing,
          team collaboration, and priority support.
        </p>

        <v-btn
          class="mt-3 w-100 text-none"
          color="primary"
          :href="`mailto:${accountExecutiveEmail}?subject=Insights%20plan%20upgrade`"
        >
          Let’s talk!
        </v-btn>
      </slot>
    </template>
  </DpplDarkTooltip>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';
import { useRouter } from 'vue-router';

const props = defineProps({
  noEditor: {
    type: Boolean,
    default: undefined,
  },
  badgeText: {
    type: String,
    default: '',
  },
  badgeStyle: {
    type: Object,
    default: () => ({ top: '-4px', left: '50%' }),
  },
  hasTooltip: {
    type: Boolean,
    default: false,
  },
  redirectRoute: {
    type: Object,
    default: null,
  },
});

const { authData } = storeToRefs(useAppAuthData());

const router = useRouter();

const isNoEditorMode = computed(() => (props.noEditor === undefined
  ? authData.value.noEditorEnabled
  : props.noEditor
));

const accountExecutiveEmail = computed(
  () => authData.value.accountExecutiveEmail || 'hello@datapeople.io',
);

const handleClick = () => {
  if (props.redirectRoute) {
    router.replace(props.redirectRoute);
  }
};
</script>

<style scoped lang="less">
.no-editor {
  position: relative;
}

.no-events {
  pointer-events: none;
  opacity: 0.7;
}

.badge {
  color: @white;
  font-size: 11px;
  font-weight: 500;
  height: 17px;
  line-height: 17px;
  padding: 0 6px;
  border-radius: 24px;
  background: linear-gradient(90deg, @bg-brand-default 0%, @indigo-100 100%);
  position: absolute;
}

.first-paragraph {
  font-size: 14px;
  font-weight: 500;
}

.second-paragraph {
  font-size: 11px;
  font-weight: 500;
}
</style>
